import React from 'react';
import TextField from 'material-ui/TextField';
import SelectFieldWrapper from 'modules/blocks/SelectFieldWrapper';
import _ from 'lodash';
import {USER_TYPE, INITIAL_USER, COUNTRIES} from 'constants/baseConst';
import {MEDICAL_TYPE, NURSE_TYPE, POSTCODE_COUNTRIES, IRELAND, DOCTOR_TYPE} from 'modules/auth/containers/constants';
import {inject} from 'mobx-react';
import {USER_UPDATE_CONSTRAINS} from 'constants/usersConstrains';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';

const UPDATE_USER = '/api/v1/users';
@inject('userStore')
@inject('alertStore')
export default class ProfileSettings extends React.Component {

  state = {
    errors: {},
    formData: _.assign({}, INITIAL_USER, this.props.userStore.user)
  };

  isNurse = () => {
    return NURSE_TYPE.includes(this.state.formData.user_type);
  };

  isMedical = () => {
    return MEDICAL_TYPE.includes(this.state.formData.user_type);
  };

  isPostcodeCountry = () => {
    const country = this.state.formData.country !== null ? COUNTRIES.find(country => country.title === this.state.formData.country) : [];
    const selectedCountry = country ? country.value : this.state.formData.country;
    return POSTCODE_COUNTRIES.includes(selectedCountry);
  };

  isIrelandDoctor = () => {
    const country = this.state.formData.country !== null ? COUNTRIES.find(country => country.title === this.state.formData.country) : [];
    const selectedCountry = country ? country.value : this.state.formData.country;
    return DOCTOR_TYPE.includes(this.state.formData.user_type) && IRELAND.includes(selectedCountry);
  };

  submit = e => {
    e.preventDefault();
    let newFormDate = _.assign({}, this.state.formData);
    if(!newFormDate.phone_number)
      newFormDate.phone_number = null;
    let errors = validate(newFormDate, USER_UPDATE_CONSTRAINS, {fullMessages: false});
    if (errors)
      this.setState({errors: errors});
    else {
      this.setState({errors: {}});
      let formData = this.state.formData;
      const country = formData.country !== null ? COUNTRIES.find(country => country.title === formData.country) : [];
      const selectedCountry = country ? country.value : formData.country;
      if(!DOCTOR_TYPE.includes(formData.user_type) && !IRELAND.includes(selectedCountry)) {
        formData.imc = '';
      } else {
        formData.nmbi = '';
      }
      new HttpClient().put(UPDATE_USER, {user: formData}).then(data => {
        const user = data.body.data.user;
        this.props.userStore.update(user);
        this.props.alertStore.success('You successfully updated your profile');
      }).catch((e) => {
        if(e.status === 422) {
          this.handleEmailError(e.body.errors);}
        else
          this.props.alertStore.success('Something went wrong');
      });
    }
  };

  handleEmailError = errors => {
    this.setState({errors})
  };

  handleChange = e => {
    if (e.target.name === 'user_type' || e.target.name === 'county')
      this.changeAdditionalForms(e);
    else {
      let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
      this.setState({formData: newState});
    }
  };

  changeAdditionalForms = e => {
    if (NURSE_TYPE.includes(e.target.value) || !MEDICAL_TYPE.includes(e.target.value)) {
      let newState = _.assign({}, this.state.formData,
        {[e.target.name]: e.target.value});
      let errors = _.assign([], this.state.errors);
      errors.nmbi = null;
      errors.imc = null;
      this.setState({formData: newState, errors: errors});
    }
    else {
      let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
      this.setState({formData: newState});
    }
  };

  render() {
    // const county = this.state.formData.county !== null ? COUNTIES.find(county => county.title === this.state.formData.county) : [];
    const country = this.state.formData.country !== null ? COUNTRIES.find(country => country.title === this.state.formData.country) : [];

    return (
      <form className="sign-up-form" onSubmit={this.submit}>
        <div className="name-info-block">
          <div className="input-wrap">
            <TextField
              onChange={this.handleChange}
              className='name'
              name="first_name"
              disabled={this.props.userStore.user.first_name  ? true : false}
              value={this.state.formData.first_name}
              floatingLabelText="First Name"
              type="text"
              errorText={this.state.errors.first_name}
            />
          </div>
          <div className="input-wrap">
            <TextField
              className='surname'
              name="last_name"
              disabled={this.props.userStore.user.last_name  ? true : false}
              value={this.state.formData.last_name}
              errorText={this.state.errors.last_name}
              onChange={this.handleChange}
              floatingLabelText="Surname"
              type="text"
            />
          </div>
        </div>
        <div className="input-wrap">
          <TextField
            name="email"
            disabled={this.props.userStore.user.email ? true : false}
            value={this.state.formData.email}
            onChange={this.handleChange}
            className='email'
            errorText={this.state.errors.email}
            floatingLabelText="Email"
            type="email"
          />
        </div>
        <div className="input-wrap select-wrap">
          <SelectFieldWrapper
            elements={USER_TYPE}
            placeholder="I am a:"
            name='user_type'
            value={this.state.formData.user_type !== null ?  this.state.formData.user_type : []}
            onChange={this.handleChange}
            errorText={this.state.errors.user_type}
            style={{position: 'absolute'}}
            className="select"
          />
        </div>
        <div className="input-wrap select-wrap">
          <SelectFieldWrapper
            elements={COUNTRIES}
            placeholder="Country"
            name='country'
            value={country ? country.value : this.state.formData.country}
            onChange={this.handleChange}
            errorText={this.state.errors.country}
            style={{position: 'absolute'}}
            className="select"
          />
        </div>
        {this.isPostcodeCountry() &&
          <div className="input-wrap">
            <TextField
              name="postcode"
              value={this.state.formData.postcode}
              onChange={this.handleChange}
              className='name'
              errorText={this.state.errors.postcode}
              floatingLabelText="Postcode/Zipcode"
              type="text"
            />
          </div>
        }
        {/* {this.isNurse() && <div className="input-wrap"
                                        key="nmbi">
                <TextField
                  onChange={this.handleChange}
                  value={this.state.formData.nmbi}
                  className='name'
                  errorText={this.state.errors.nmbi}
                  name="nmbi"
                  floatingLabelText="NMBI Number"
                  type="text"
                />
        </div>} */}
        {this.isIrelandDoctor() && <div className="input-wrap"
                                  key="imc">
          <TextField
            onChange={this.handleChange}
            value={this.state.formData.imc}
            className='name'
            name="imc"
            errorText={this.state.errors.imc}
            floatingLabelText="IMC Number"
            type="text"
          />
        </div>}
      { /* <div className="input-wrap">
          <TextField
            onChange={this.handleChange}
            value={this.state.formData.phone_number || ''}
            className='phone'
            errorText={this.state.errors.phone_number}
            name="phone_number"
            floatingLabelText="Phone"
            type="text"
          />
        </div>*/}

        {/* {this.state.formData.user_type !== 4 &&
          <div className="input-wrap select-wrap">
            <SelectFieldWrapper
              elements={COUNTIES}
              placeholder="County"
              name='county'
              value={county ? county.value : this.state.formData.county}
              onChange={this.handleChange}
              errorText={this.state.errors.county}
              style={{position: 'absolute'}}
              className="select"
            />
          </div>
        } */}
        {/* {this.state.formData.user_type !== 4 &&
          <div className="input-wrap">
            <TextField
              onChange={this.handleChange}
              value={this.state.formData.practice_address || ''}
              className='phone'
              errorText={this.state.errors.practice_address}
              name="practice_address"
              floatingLabelText="Practice Address"
              maxLength={50}
              type="text"
            />
          </div>
        } */}
        <div className="button-set">
          <button className="btn blue rounded update-btn" type="submit">save</button>
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/profile/components/ProfileSettings.js